import { NXT_AUTH_GUARD } from '@nxtpeople/nxt-vue-keycloak';
import type { Router, RouteRecordRaw } from 'vue-router';
import QUERY_GUARD from './query.guard';
import TITLE_GUARD from './title.guard';
import UNAVAILABLE_GUARD from './unavailable.guard';
import USER_PERMISSION_GUARD from './user-permission.guard';

const CHUNK_ERROR_PATTERNS = [
   'Failed to fetch dynamically imported module',
   'error loading dynamically imported module', // Safari
   'Importing a module script failed',
   'Unable to preload CSS',
];

export function registerGuards(router: Router, privateRoutes: Array<RouteRecordRaw>) {
   // Must be registered before nxt-styles registers its own onError handler (which only handles
   // Chrome/Firefox chunk errors and shows a toast for anything else, including Safari's variant).
   router.onError((error, to) => {
      const message = error instanceof Error ? error.message : String(error ?? '');
      if (!CHUNK_ERROR_PATTERNS.some((p) => message.includes(p))) return;

      if (!sessionStorage.getItem('chunk-load-error-reloaded')) {
         sessionStorage.setItem('chunk-load-error-reloaded', 'true');
         window.location.replace(to.fullPath);
      }
   });

   router.beforeEach(UNAVAILABLE_GUARD);
   router.beforeEach((to, from, next) => NXT_AUTH_GUARD(to, from, next, { privateRoutes }));
   router.beforeEach(USER_PERMISSION_GUARD);
   router.beforeEach(TITLE_GUARD);
   router.beforeEach(QUERY_GUARD);
}
